import api from '@/api'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  clearDevices({ commit }) {
    commit(types.CLEAR_DEVICES)
  },
  clearFound({ commit }) {
    commit(types.CLEAR_FOUND_DEVICES)
  },
  initDeviceModel({ commit }, data) {
    console.log('test', data)
    return new Promise((resolve, reject) => {
      api.getDeviceById(data)
        .then(response => {
          commit(types.INIT_DEVICE_DATA, response.data)
          resolve(response)
        })
    })
  },
  setActiveTab({ commit, state }, tab) {
    commit(types.SET_ACTIVE_TAB, tab)
  },
  setSource({ commit }, source) {
    commit(types.SET_SOURCE, source)
  },
  async getDevice({ commit, dispatch }, serialNumber) {
    return new Promise((resolve, reject) => {
      api.getDevice(serialNumber)
        .then(response => {
          commit(types.SET_DEVICE, response.data)
          resolve(response)
        })
    })
  },
  async getDeviceById({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getDeviceById(id)
        .then(response => {
          commit(types.SET_DEVICE, response.data)
          resolve(response)
        })
    })
  },
  async getDeviceFileById({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getDeviceFileById(id)
        .then(response => {
          commit(types.SET_DEVICEFILE, response.data)
          resolve(response)
        })
    })
  },
  async getDevices({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getDevices(searchOptions)
        .then(response => {
          commit(types.SET_DEVICES, response.data)
          resolve(response)
        })
    })
  },
  async getDevicefiles({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getdevicefiles(searchOptions)
        .then(response => {
          commit(types.SET_DEVICEFILES, response.data)
          resolve(response)
        })
    })
  },
  async searchDevices({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getDevices(searchOptions)
        .then(response => {
          commit(types.SET_FOUND_DEVICES, response.data)
          resolve(response)
        })
    })
  },
  async getAssociatedDevices({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getDevices(searchOptions)
        .then(response => {
          if (searchOptions.deviceId > 0) {
            response.data = response.data.filter((obj) => obj.Id !== searchOptions.deviceId)
          }

          commit(types.SET_ASSOCIATED_DEVICES, response.data)
          resolve(response)
        })
    })
  },
  async activateDevice({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.activateDevice(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getDeviceActivation({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getDeviceActivation(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async downloadAllTools({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.downloadAllTools(id)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getTools({ commit, dispatch }, searchOptions) {
    return new Promise((resolve, reject) => {
      api.getTools(searchOptions)
        .then(response => {
          commit(types.SET_TOOLS, response.data)
          resolve(response)
        })
    })
  },
  async updateDeviceFile({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.updateDeviceFile(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async updateDevice({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.updateDevice(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async upsertDeviceShipment({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.upsertDeviceShipment(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async createDevice({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.createDevice(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getToolMakes({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getToolMakes(id)
        .then(response => {
          commit(types.SET_TOOL_MAKES, response.data)
          resolve(response)
        })
    })
  },
  async addToolMake({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.addToolMake(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async deleteToolMake({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.deleteToolMake(id)
        .then(response => {
          resolve(response)
        })
    })
  },
  async assignDevice({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.assignDevice(data)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/devices/actions.js